module.exports = __webpack_public_path__ + "static/media/41.1bb4a5a2.png";